<app-topnav [pageName]="pageName"></app-topnav>
<div class="dashboard-page-container">
  <div class="content dashboard-page" role="main" [class.dashboard-page--analytics]="dashboardModel.analyticsVisible || dashboardModel.bbAdminDashboardVisible">
    <header class="dashboard-page__header">
      <div>
        <h1 class="dashboard-page__title">Dashboard</h1>
        @if (dashboardModel.analyticsVisible) {
          <p class="dashboard-page__subtitle">
            Monitor platform health, invitations, and participant activity.
          </p>
        }
        @if (dashboardModel.bbAdminDashboardVisible) {
          <p class="dashboard-page__subtitle">
            BounceBack overview and quick access based on your role and permissions.
          </p>
        }
      </div>
      @if (dashboardModel.showCourseExtractButton || dashboardModel.showParticipantExtractButton) {
        <div class="dashboard-page__actions">
          @if (dashboardModel.showCourseExtractButton) {
            <button
              class="dashboard-page__action dashboard-page__action--secondary"
              type="button"
              name="createcoursereport"
              (click)="opencoursereportmodal()"
              >
              <mat-icon>description</mat-icon>
              Course Report
            </button>
          }
          @if (dashboardModel.showParticipantExtractButton) {
            <button
              class="dashboard-page__action dashboard-page__action--primary"
              type="button"
              name="createparticipantreport"
              (click)="openparticipantreportmodal()"
              >
              <mat-icon>people</mat-icon>
              Participant Report
            </button>
          }
        </div>
      }
    </header>

    @if (dashboardModel.analyticsVisible) {
      <app-dashboard-devadmin [dashboardModel]="dashboardModel"></app-dashboard-devadmin>
    }
    @if (dashboardModel.bbAdminDashboardVisible) {
      <app-dashboard-bbprogramadministrator [dashboardModel]="dashboardModel"></app-dashboard-bbprogramadministrator>
    }
  </div>
</div>

<app-footer [bbapp]="true"></app-footer>
